import { PERIOD } from '../shared/CommonConstants';
import {
    ALL_STUDENT_SUMMARY_PDF,
    CLASS_SUMMARY_PDF,
    ALL_PM_GRAPHS_PDF,
} from '../shared/PdfGenerationConstants';
import { RAN_TITLE, VOCABO_TITLE, OL_TITLE, SPELL_TITLE } from '../../utils/reading/helpUtils';

export const DEMO_TYPES = {
    GUIDED_TOUR: 'Guided Tour',
    SELF_EXPLORE: 'Self Explore',
    DEFAULT: 'DEFAULT',
};

export const POINTER_EVENTS = 'pointer-events';
export const STUDENT_ID = 'studentId';
export const ACTIVITIES_SECTION = 'activities-section';
export const ACTIVITIES_LIST = 'activities-list';
export const ACTIVITIES_TITLE = 'activities-title';
export const BLURB_UPDATE_REC = 'blurb-update-recommendations';
export const CLASS_SUM_REP_TABLE = 'class-summary-report-table';
export const CLASS_DROPDOWN = 'class-dropdown';
export const HOME_CON_TABLE = 'home-connect-table';
export const MEASURE_LIST_TOP = 'measure-list-top';
export const OBSERVED_PATTERNS = 'observed-patterns';
export const PROG_ZOG_TABLE = 'prog-zog-gro-results-table';
export const RUNNING_GIRL = 'running-girl';
export const SUB_HEAD_COMP_COL = 'sub-header-composite-column';
export const SUB_HEAD_NAM_COL = 'sub-header-name-column';
export const STUD_NAME_GROUP_DES = 'student-name-group-description';
export const WORD_LET_PROB_DET = 'word-letter-probe-details';
export const NWFCLS_GRID = 'nwfclsmeasuredatagrid';
export const MAZE_CLASSNAME = 'dark-right-border maze-cell';
export const SAMEER_FN = 'Sameer';
export const CLOSE_PROBE_DETAILS = 'close-probe-details';
export const HOME_CONNECT_ENG_SPA_COL = 'home-eng-spa-col';
export const D8_HELP_LABEL = 'DIBELS 8th Edition';
export const DEMO_PDF = 'Demo.pdf';

export const HELP_ITEMS_DEMO = [D8_HELP_LABEL, RAN_TITLE, VOCABO_TITLE, OL_TITLE, SPELL_TITLE];

export const DATA_TOUR_STEP_MAPPER = {
    composite: 'composite',
    letternameslnf: 'letternameslnf',
    31: '31',
    name: 'name',
    skillsresources: 'skillsresources',
    nwfcls: 'nwfcls-data-cell',
    nwfclsmeasuredatagrid: 'nwfcls-measure-data-grid',
    boy: 'boy',
    moy: 'moy',
    goalsetting: 'goalsetting',
    growthoutcomes: 'growthoutcomes',
    students: 'students',
    allactivities: 'allactivities',
    '01': '01',
    demoresulttable2: 'demoresulttable2',
    benchmark: 'benchmark',
    progress: 'progress',
    homeconnect: 'homeconnect',
    instruction: 'instruction',
    lnf: 'lnf',
    spell: 'spell',
    emibrownlnf: 'emibrownlnf',
    emibrown: 'emibrown',
    sameerali: 'sameerali',
    groups: 'groups',
    last3pmscores: 'last3pmscores',
    moygoal: 'moygoal',
    aimlinetogoalset: 'aimlinetogoalset',
    'zonesofgrowth-table': 'zonesofgrowth-table',
    'progressmonitoring-table': 'progressmonitoring-table',
};

export const DATA_TOUR_INTERACTION_MAPPER = {
    boy: true,
    goalsetting: true,
    growthoutcomes: true,
    students: true,
    allactivities: true,
    kg: true,
    emibrownlnf: true,
    '01': true,
};

export const SEE_MORE_BUTTON = '[data-tour-step="see-more-button"]';

export const DEFAULT_DEMO_TYPE = DEMO_TYPES.DEFAULT;

export const DEMO_CLASS_1 = '1';
export const DEMO_CLASS_2 = '2';
export const DEMO_CLASS_3 = '3';
export const DEMO_CLASS_4 = '4';

export const DEMO_CLASS_GRADES = {
    [DEMO_CLASS_1]: 'K',
    [DEMO_CLASS_2]: '1',
    [DEMO_CLASS_3]: '3',
    [DEMO_CLASS_4]: '4',
};
export const DEFAULT_DEMO_CLASS = DEMO_CLASS_2;

const D8RESULTSDATAGRADEK = 'demoD8ResultsResponseGradeK.json';
const D8RESULTSDATAGRADE1 = 'demoD8ResultsResponseGrade1.json';
const D8RESULTSDATAGRADE3 = 'demoD8ResultsResponseGrade3.json';
const D8RESULTSDATAGRADE4 = 'demoD8ResultsResponseGrade4.json';

const OLRESULTSDATAGRADE1 = 'demoOLResultsResponseGrade1.json';
const SPELLRESULTSDATAGRADEKG = 'demoSPELLResultsResponseGradeKG.json';
const SPELLRESULTSDATAGRADE1 = 'demoSPELLResultsResponseGrade1.json';
const VOCRESULTSDATAGRADEKG = 'demoVOCResultsResponseGradeKG.json';
const VOCRESULTSDATAGRADE1 = 'demoVOCResultsResponseGrade1.json';
const RANRESULTSDATAGRADEKG = 'demoRANResultsResponseGradeKG.json';
const RANRESULTSDATAGRADE1 = 'demoRANResultsResponseGrade1.json';

const CHKPOINTGRADE1 = 'demoCheckpointResponseGrade1.json';
const CHKPOINTGRADE3 = 'demoCheckpointResponseGrade3.json';
const CHKPOINTGRADE4 = 'demoCheckpointResponseGrade4.json';
const CHKPOINTGRADEK = 'demoCheckpointResponseGradeK.json';

const ENROLLRESGRADE1 = 'demoEnrollmentResponseGrade1.json';
const ENROLLRESGRADE3 = 'demoEnrollmentResponseGrade3.json';
const ENROLLRESGRADE4 = 'demoEnrollmentResponseGrade4.json';
const ENROLLRESGRADEK = 'demoEnrollmentResponseGradeK.json';

const STUDENTSUMGRADE1 = 'demoStudentSummaryResponsesGrade1.json';
const STUDENTSUMGRADE3 = 'demoStudentSummaryResponsesGrade3.json';
const STUDENTSUMGRADE4 = 'demoStudentSummaryResponsesGrade4.json';
const STUDENTSUMGRADEK = 'demoStudentSummaryResponsesGradeK.json';

const STAFFENROLL = 'demoStaffEnrollmentReponse.json';

const MAZEINTERP = 'demoMAZEInterpsResponse.json';
const VOCINTERPS = 'demoVOCInterpsResponse.json';
const RANINTERP = 'demoRANInterpsResponse.json';
const COMPINTERP = 'demoCompositeInterpsResponse.json';
const D8INTERP = 'demoD8InterpsResponse.json';
const SPELLINTERP = 'demoSpellingInterpsResponse.json';
const OLINTERP = 'demoOLInterpsResponse.json';

const OBSERVRES = 'demoObservationResponse.json';
const APPCONFIGRES = 'demoModeAppConfigResponse.json';

const CLASS_SUMMARY_MOY_KG = 'ClassSummaryMOY-KG-Demo.pdf';
const CLASS_SUMMARY_EOY_KG = 'ClassSummaryEOY-KG-Demo.pdf';
const CLASS_SUMMARY_BOY_KG = 'ClassSummaryBOY-KG-Demo.pdf';
const ALL_STUDENT_SUMMARIES_KG = 'AllStudentSummaries-KG-Demo.pdf';
const ALL_PM_GRAPHS_KG = 'AllPMGraphs-KG-Demo.pdf';

const CLASS_SUMMARY_MOY_G1 = 'ClassSummaryMOY-G1-Demo.pdf';
const CLASS_SUMMARY_EOY_G1 = 'ClassSummaryEOY-G1-Demo.pdf';
const CLASS_SUMMARY_BOY_G1 = 'ClassSummaryBOY-G1-Demo.pdf';
const ALL_STUDENT_SUMMARIES_G1 = 'AllStudentSummaries-G1-Demo.pdf';
const ALL_PM_GRAPHS_G1 = 'AllPMGraphs-G1-Demo.pdf';

const CLASS_SUMMARY_MOY_G3 = 'ClassSummaryMOY-G3-Demo.pdf';
const CLASS_SUMMARY_EOY_G3 = 'ClassSummaryEOY-G3-Demo.pdf';
const CLASS_SUMMARY_BOY_G3 = 'ClassSummaryBOY-G3-Demo.pdf';
const ALL_STUDENT_SUMMARIES_G3 = 'AllStudentSummaries-G3-Demo.pdf';
const ALL_PM_GRAPHS_G3 = 'AllPMGraphs-G3-Demo.pdf';

const CLASS_SUMMARY_MOY_G4 = 'ClassSummaryMOY-G4-Demo.pdf';
const CLASS_SUMMARY_EOY_G4 = 'ClassSummaryEOY-G4-Demo.pdf';
const CLASS_SUMMARY_BOY_G4 = 'ClassSummaryBOY-G4-Demo.pdf';
const ALL_STUDENT_SUMMARIES_G4 = 'AllStudentSummaries-G4-Demo.pdf';
const ALL_PM_GRAPHS_G4 = 'AllPMGraphs-G4-Demo.pdf';

export const STATIC_D8_RESULTS = {
    [DEMO_CLASS_1]: 'D8K',
    [DEMO_CLASS_2]: 'D81',
    [DEMO_CLASS_3]: 'D83',
    [DEMO_CLASS_4]: 'D84',
};

export const STATIC_OL_RESULTS = {
    [DEMO_CLASS_1]: 'OLK',
    [DEMO_CLASS_2]: 'OL1',
    [DEMO_CLASS_3]: 'OL3',
    [DEMO_CLASS_4]: 'OL4',
};

export const STATIC_SPELL_RESULTS = {
    [DEMO_CLASS_1]: 'SPLK',
    [DEMO_CLASS_2]: 'SPL1',
    [DEMO_CLASS_3]: 'SPL3',
    [DEMO_CLASS_4]: 'SPL4',
};

export const STATIC_VOC_RESULTS = {
    [DEMO_CLASS_1]: 'VOCK',
    [DEMO_CLASS_2]: 'VOC1',
    [DEMO_CLASS_3]: 'VOC3',
    [DEMO_CLASS_4]: 'VOC4',
};

export const STATIC_RAN_RESULTS = {
    [DEMO_CLASS_1]: 'RANK',
    [DEMO_CLASS_2]: 'RAN1',
    [DEMO_CLASS_3]: 'RAN3',
    [DEMO_CLASS_4]: 'RAN4',
};

export const STATIC_SUMMARY_GRADES = {
    [DEMO_CLASS_1]: 'STU_SUM_K',
    [DEMO_CLASS_2]: 'STU_SUM_1',
    [DEMO_CLASS_3]: 'STU_SUM_3',
    [DEMO_CLASS_4]: 'STU_SUM_4',
};
export const STATIC_ENROLLMENT_DATA = {
    [DEMO_CLASS_1]: 'ENROLL_K',
    [DEMO_CLASS_2]: 'ENROLL_1',
    [DEMO_CLASS_3]: 'ENROLL_3',
    [DEMO_CLASS_4]: 'ENROLL_4',
};
export const STATIC_CHECKPOINT_DATA = {
    [DEMO_CLASS_1]: 'CHKPT_K',
    [DEMO_CLASS_2]: 'CHKPT_1',
    [DEMO_CLASS_3]: 'CHKPT_3',
    [DEMO_CLASS_4]: 'CHKPT_4',
};
export const STATIC_STAFF_ENROLL = 'STAFF_ENROLL';
export const STATIC_MAZE_INTERP = 'MAZE_INTERP';
export const STATIC_VOC_INTERP = 'VOC_INTERP';
export const STATIC_RAN_INTERP = 'RAN_INTERP';
export const STATIC_COMP_INTERP = 'COMP_INTERP';
export const STATIC_D8_INTERP = 'D8_INTERP';
export const STATIC_SPELL_INTERP = 'SPELL_INTERP';
export const STATIC_OL_INTERP = 'OL_INTERP';
export const STATIC_APP_CONFIG = 'APP_CONFIG';

export const STATIC_OBSERV_RES = 'OBSERV_RES';

export const ALL_STATIC_DEMO_DATA = [
    D8RESULTSDATAGRADEK,
    D8RESULTSDATAGRADE1,
    D8RESULTSDATAGRADE3,
    D8RESULTSDATAGRADE4,
    OLRESULTSDATAGRADE1,
    SPELLRESULTSDATAGRADEKG,
    SPELLRESULTSDATAGRADE1,
    VOCRESULTSDATAGRADEKG,
    VOCRESULTSDATAGRADE1,
    RANRESULTSDATAGRADEKG,
    RANRESULTSDATAGRADE1,
    CHKPOINTGRADE1,
    CHKPOINTGRADE3,
    CHKPOINTGRADE4,
    CHKPOINTGRADEK,
    ENROLLRESGRADE1,
    ENROLLRESGRADE3,
    ENROLLRESGRADE4,
    ENROLLRESGRADEK,
    STUDENTSUMGRADE1,
    STUDENTSUMGRADE3,
    STUDENTSUMGRADE4,
    STUDENTSUMGRADEK,
    STAFFENROLL,
    MAZEINTERP,
    VOCINTERPS,
    RANINTERP,
    COMPINTERP,
    D8INTERP,
    SPELLINTERP,
    OLINTERP,
    OBSERVRES,
    APPCONFIGRES,
];

export const DEMO_MAPPER = {
    [D8RESULTSDATAGRADEK]: 'D8K',
    [D8RESULTSDATAGRADE1]: 'D81',
    [D8RESULTSDATAGRADE3]: 'D83',
    [D8RESULTSDATAGRADE4]: 'D84',
    [OLRESULTSDATAGRADE1]: 'OL1',
    [SPELLRESULTSDATAGRADEKG]: 'SPLK',
    [SPELLRESULTSDATAGRADE1]: 'SPL1',
    [VOCRESULTSDATAGRADEKG]: 'VOCK',
    [VOCRESULTSDATAGRADE1]: 'VOC1',
    [RANRESULTSDATAGRADEKG]: 'RANK',
    [RANRESULTSDATAGRADE1]: 'RAN1',
    [CHKPOINTGRADE1]: 'CHKPT_1',
    [CHKPOINTGRADE3]: 'CHKPT_3',
    [CHKPOINTGRADE4]: 'CHKPT_4',
    [CHKPOINTGRADEK]: 'CHKPT_K',
    [ENROLLRESGRADE1]: 'ENROLL_1',
    [ENROLLRESGRADE3]: 'ENROLL_3',
    [ENROLLRESGRADE4]: 'ENROLL_4',
    [ENROLLRESGRADEK]: 'ENROLL_K',
    [STUDENTSUMGRADE1]: 'STU_SUM_1',
    [STUDENTSUMGRADE3]: 'STU_SUM_3',
    [STUDENTSUMGRADE4]: 'STU_SUM_4',
    [STUDENTSUMGRADEK]: 'STU_SUM_K',
    [STAFFENROLL]: 'STAFF_ENROLL',
    [MAZEINTERP]: 'MAZE_INTERP',
    [VOCINTERPS]: 'VOC_INTERP',
    [RANINTERP]: 'RAN_INTERP',
    [COMPINTERP]: 'COMP_INTERP',
    [D8INTERP]: 'D8_INTERP',
    [SPELLINTERP]: 'SPELL_INTERP',
    [OLINTERP]: 'OL_INTERP',
    [OBSERVRES]: 'OBSERV_RES',
    [APPCONFIGRES]: 'APP_CONFIG',
};

export const STEP = [
    'step-0',
    'step-1',
    'step-2',
    'step-3',
    'step-4',
    'step-5',
    'step-6',
    'step-7',
    'step-8',
    'step-9',
    'step-10',
    'step-11',
    'step-12',
    'step-13',
    'step-14',
    'step-15',
    'step-16',
    'step-17',
    'step-18',
    'step-19',
    'step-20',
    'step-21',
    'step-22',
    'step-23',
    'step-24',
    'step-25',
    'step-26',
    'step-27',
    'step-28',
    'step-29',
    'step-30',
    'step-31',
    'step-32',
    'step-33',
    'step-34',
    'step-35',
    'step-36',
    'step-37',
    'step-38',
    'step-39',
    'step-40',
    'step-41',
    'step-42',
    'step-43',
    'step-44',
    'step-45',
    'step-46',
    'step-47',
    'step-48',
    'step-49',
    'step-50',
    'step-51',
];

export const PDF_STATIC_DEMO_MAPPER = {
    [DEMO_CLASS_1]: {
        [CLASS_SUMMARY_PDF]: {
            [PERIOD.BOY]: CLASS_SUMMARY_BOY_KG,
            [PERIOD.MOY]: CLASS_SUMMARY_MOY_KG,
            [PERIOD.EOY]: CLASS_SUMMARY_EOY_KG,
        },
        [ALL_STUDENT_SUMMARY_PDF]: ALL_STUDENT_SUMMARIES_KG,
        [ALL_PM_GRAPHS_PDF]: ALL_PM_GRAPHS_KG,
    },
    [DEMO_CLASS_2]: {
        [CLASS_SUMMARY_PDF]: {
            [PERIOD.BOY]: CLASS_SUMMARY_BOY_G1,
            [PERIOD.MOY]: CLASS_SUMMARY_MOY_G1,
            [PERIOD.EOY]: CLASS_SUMMARY_EOY_G1,
        },
        [ALL_STUDENT_SUMMARY_PDF]: ALL_STUDENT_SUMMARIES_G1,
        [ALL_PM_GRAPHS_PDF]: ALL_PM_GRAPHS_G1,
    },
    [DEMO_CLASS_3]: {
        [CLASS_SUMMARY_PDF]: {
            [PERIOD.BOY]: CLASS_SUMMARY_BOY_G3,
            [PERIOD.MOY]: CLASS_SUMMARY_MOY_G3,
            [PERIOD.EOY]: CLASS_SUMMARY_EOY_G3,
        },
        [ALL_STUDENT_SUMMARY_PDF]: ALL_STUDENT_SUMMARIES_G3,
        [ALL_PM_GRAPHS_PDF]: ALL_PM_GRAPHS_G3,
    },
    [DEMO_CLASS_4]: {
        [CLASS_SUMMARY_PDF]: {
            [PERIOD.BOY]: CLASS_SUMMARY_BOY_G4,
            [PERIOD.MOY]: CLASS_SUMMARY_MOY_G4,
            [PERIOD.EOY]: CLASS_SUMMARY_EOY_G4,
        },
        [ALL_STUDENT_SUMMARY_PDF]: ALL_STUDENT_SUMMARIES_G4,
        [ALL_PM_GRAPHS_PDF]: ALL_PM_GRAPHS_G4,
    },
};
